var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudioUiGen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6.15,
    height: 1.71,
    viewBox: "0 0 6.15 1.71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.1413 0.01V0.92313L5.36047 1.70145H0.01V0.78481L0.794986 0.01H6.1413Z",
    fill: "#07D1AE",
    stroke: "url(#paint0_linear_304_239)",
    strokeWidth: 0.02
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.51006 1.04782C2.46443 1.04782 2.42904 1.03674 2.4039 1.01458C2.3791 0.992423 2.3667 0.959517 2.3667 0.915863V0.701559H2.4302V0.914374C2.4302 0.940501 2.43714 0.960344 2.45103 0.973903C2.46492 0.987462 2.4846 0.994242 2.51006 0.994242C2.53553 0.994242 2.55537 0.987462 2.56959 0.973903C2.58381 0.960344 2.59092 0.940501 2.59092 0.914374V0.701559H2.65442V0.915863C2.65442 0.959517 2.64185 0.992423 2.61672 1.01458C2.59159 1.03674 2.55603 1.04782 2.51006 1.04782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.72719 0.701559H2.79019V1.04187H2.72719V0.701559Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.01556 1.04782C2.96166 1.04782 2.92048 1.03343 2.89204 1.00466C2.8636 0.975557 2.84938 0.931241 2.84938 0.871712C2.84938 0.812845 2.86426 0.76886 2.89402 0.739757C2.92412 0.710323 2.96711 0.695606 3.023 0.695606C3.05277 0.695606 3.07956 0.700236 3.10337 0.709496C3.12751 0.718426 3.14653 0.731985 3.16042 0.750174C3.17464 0.768364 3.18175 0.790852 3.18175 0.81764H3.11627C3.11627 0.796144 3.1075 0.779443 3.08997 0.767537C3.07245 0.7553 3.05062 0.749182 3.02449 0.749182C2.98745 0.749182 2.95984 0.758938 2.94165 0.77845C2.92346 0.797963 2.91436 0.827396 2.91436 0.866751V0.876673C2.91469 0.917351 2.92329 0.947115 2.94016 0.965966C2.95736 0.984817 2.98348 0.994242 3.01854 0.994242C3.04963 0.994242 3.07393 0.987132 3.09146 0.972911C3.10932 0.95869 3.11825 0.938682 3.11825 0.912886V0.91239H3.00911V0.859806H3.18175V1.04187H3.1366L3.13115 1.00416C3.11627 1.01905 3.09956 1.03012 3.08104 1.0374C3.06252 1.04435 3.0407 1.04782 3.01556 1.04782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35702 1.04782C3.31469 1.04782 3.28327 1.03674 3.26277 1.01458C3.24226 0.992423 3.23201 0.958029 3.23201 0.911398C3.23201 0.864767 3.24226 0.830373 3.26277 0.808215C3.2836 0.786057 3.31502 0.774978 3.35702 0.774978C3.39538 0.774978 3.42399 0.785726 3.44284 0.807223C3.46202 0.828719 3.47161 0.862287 3.47161 0.907925V0.925784H3.29253C3.29352 0.95158 3.29898 0.970596 3.3089 0.982832C3.31915 0.994738 3.33536 1.00069 3.35752 1.00069C3.37405 1.00069 3.38745 0.996557 3.3977 0.988289C3.40795 0.979691 3.41308 0.967123 3.41308 0.950588H3.47161C3.47161 0.982667 3.46103 1.00697 3.43986 1.02351C3.4187 1.03972 3.39108 1.04782 3.35702 1.04782ZM3.4096 0.883618C3.4096 0.842609 3.39208 0.822105 3.35702 0.822105C3.33718 0.822105 3.32213 0.827231 3.31188 0.837483C3.30196 0.847404 3.29584 0.862783 3.29352 0.883618H3.4096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52403 0.780931H3.57314L3.5781 0.815656H3.58157C3.59116 0.802758 3.6029 0.792836 3.61679 0.785891C3.63102 0.778616 3.64722 0.774978 3.66541 0.774978C3.69187 0.774978 3.71254 0.782254 3.72742 0.796805C3.7423 0.811026 3.74974 0.834011 3.74974 0.865759V1.04187H3.69021V0.876177C3.69021 0.858318 3.68608 0.845586 3.67781 0.837979C3.66987 0.830373 3.65797 0.826569 3.64209 0.826569C3.62556 0.826569 3.61167 0.832522 3.60042 0.844428C3.58918 0.856334 3.58356 0.871547 3.58356 0.890067V1.04187H3.52403V0.780931Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_304_239",
    x1: -0.496073,
    y1: -0.520876,
    x2: 5.72964,
    y2: 1.61224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.1513,
    height: 1.71145,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudioUiGen);
export default __webpack_public_path__ + "static/media/studio_UIGen.641943d641ef79af3cb03fdf181670ed.svg";
export { ForwardRef as ReactComponent };